import type { HistoryPoint, Session, WishlistGame, WishlistOffer } from "./types";

function offer(
  id: number,
  gameId: number,
  store: string,
  label: string,
  price: number | null,
  discount: number | null,
  extras: Partial<WishlistOffer> = {},
): WishlistOffer {
  return {
    id,
    game_id: gameId,
    store,
    group: store.startsWith("ps_") ? "playstation" : "steam",
    label,
    title: null,
    url: "https://example.com",
    offer_type: "store",
    platform: null,
    currency: store === "steam_kz" ? "KZT" : store.startsWith("ps_") ? "TRY" : "RUB",
    price_minor: price === null ? null : Math.round(price * 100),
    base_price_minor: price === null ? null : Math.round(price * 100 * (discount ? 2 : 1)),
    price_rub: price,
    discount_percent: discount,
    sale_ends_at: discount ? "2026-08-08T18:00:00+00:00" : null,
    ps_plus_price_minor: null,
    ps_plus_price_rub: null,
    ps_plus_discount_percent: null,
    ps_plus_tier: null,
    effective_price_rub: price,
    effective_price_kind: price === null ? null : "standard",
    release_date: null,
    early_access_date: null,
    steam_personalized: false,
    localization_status: "text_audio",
    checked_at: "2026-08-05T09:00:00",
    is_best: false,
    ...extras,
  };
}

export const mockSession: Session = {
  user_id: 100,
  name: "Prince",
  username: "prince",
  bot_username: "pt_wishlist_bot",
  csrf_token: "demo-csrf-token",
};

export const mockGames: WishlistGame[] = [
  {
    id: 1,
    version: 1,
    updated_at: "2026-08-31 00:00:00",
    title: "Tomb Raider: Legacy of Atlantis",
    poster_url: "https://shared.fastly.steamstatic.com/store_item_assets/steam/apps/3517380/library_600x900.jpg",
    status: "preorder",
    release_date: "2027-02-12",
    release_kind: "release",
    has_price: true,
    has_discount: true,
    has_ps_plus: false,
    max_discount_percent: 25,
    best_price_rub: 3479,
    best_offer_id: 2,
    best_price_kind: "standard",
    alarm_threshold_rub: null,
    alarm_triggered: false,
    offers: [
      offer(1, 1, "steam_kz", "Steam KZ", 4079, 20),
      offer(2, 1, "ps_tr", "PS Store TR", 3479, 25, { is_best: true }),
      offer(3, 1, "steambuy", "SteamBuy", 3899, 15, { currency: "RUB" }),
    ],
  },
  {
    id: 2,
    version: 1,
    updated_at: "2026-08-31 00:00:00",
    title: "Death Stranding 2: On the Beach",
    poster_url: null,
    status: "released",
    release_date: null,
    release_kind: null,
    has_price: true,
    has_discount: true,
    has_ps_plus: true,
    max_discount_percent: 40,
    best_price_rub: 2579,
    best_offer_id: 5,
    best_price_kind: "ps_plus",
    alarm_threshold_rub: 2500,
    alarm_triggered: true,
    offers: [
      offer(4, 2, "ps_tr", "PS Store TR", 3199, 20, {
        localization_status: "text",
      }),
      offer(5, 2, "ps_in", "PS Store IN", 2899, 30, {
        is_best: true,
        ps_plus_price_minor: 257900,
        ps_plus_price_rub: 2579,
        ps_plus_discount_percent: 40,
        ps_plus_tier: "Extra",
        effective_price_rub: 2579,
        effective_price_kind: "ps_plus",
      }),
    ],
  },
  {
    id: 3,
    version: 1,
    updated_at: "2026-08-31 00:00:00",
    title: "Hollow Knight: Silksong",
    poster_url: null,
    status: "waiting",
    release_date: "2027-06-01",
    release_kind: "release",
    has_price: false,
    has_discount: false,
    has_ps_plus: false,
    max_discount_percent: null,
    best_price_rub: null,
    best_offer_id: null,
    best_price_kind: null,
    alarm_threshold_rub: null,
    alarm_triggered: false,
    offers: [offer(6, 3, "steam_kz", "Steam KZ", null, null)],
  },
  {
    id: 4,
    version: 1,
    updated_at: "2026-08-31 00:00:00",
    title: "Portal 2",
    poster_url: null,
    status: "released",
    release_date: null,
    release_kind: null,
    has_price: true,
    has_discount: true,
    has_ps_plus: false,
    max_discount_percent: 90,
    best_price_rub: 79,
    best_offer_id: 7,
    best_price_kind: "standard",
    alarm_threshold_rub: null,
    alarm_triggered: false,
    offers: [offer(7, 4, "steam_kz", "Steam KZ", 79, 90, { is_best: true })],
  },
];

export const mockHistory: Record<number, HistoryPoint[]> = Object.fromEntries(
  mockGames.map((game, gameIndex) => [
    game.id,
    game.offers.flatMap((item, offerIndex) =>
      [0, 1, 2, 3, 4].map((step) => ({
        offer_id: item.id,
        store: item.store,
        label: item.label,
        checked_at: new Date(2026, 3 + step, 4 + offerIndex).toISOString(),
        currency: item.currency ?? "RUB",
        price_minor: Math.round(((item.price_rub ?? 1800) * (1.55 - step * 0.11)) * 100),
        price_rub: Math.round((item.price_rub ?? 1800) * (1.55 - step * 0.11) + gameIndex * 30),
        discount_percent: step >= 3 ? item.discount_percent : null,
      })),
    ),
  ]),
);
